import i18next from 'i18next';
import { useQuery } from 'react-query';
import { setToast } from '../../../store/core/coreSlice';
import { store } from '../../../store/store';
import { apiRQ } from '../../api';

// Exported so a caller (e.g. `DocForm.tsx`) can check the same threshold itself against the
// `refetch()` result, to decide whether to skip a toast that would otherwise clobber this hook's
// own low-credits one.
export const ALERT_CREDITS_LIMIT = 200;

const getTotalUsableCredits = async (): Promise<number> => {
  const resp = await apiRQ.get<number>('/credits/remaining/');
  return resp.data || 0;
};

export const useRemainingCredits = (enabled = false) => {
  return useQuery<number, Error>(['useRemainingCredits'], getTotalUsableCredits, {
    cacheTime: 2000,
    staleTime: 2000,
    refetchOnWindowFocus: false,
    enabled,
    onSuccess: (data) => {
      if (data < ALERT_CREDITS_LIMIT) {
        store.dispatch(
          setToast({
            value: {
              show: true,
              header: i18next.t('PLANS.LOW_CREDITS_HEADER'),
              msg: i18next.t('PLANS.LOW_CREDITS_MESSAGE', { credits: data }),
              isError: false,
              duration: 20000,
            },
          }),
        );
      }
    },
  });
};
